import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './components/App/App.tsx';
import { initMetaTagsFromHash } from './utils/metaTags.ts';

const LANG_KEY = 'stonpools-lang';
const DEFAULT_LANG: 'ru' | 'en' = 'en';

function resolveInitialLang(): 'ru' | 'en' {
  if (typeof localStorage === 'undefined') {
    return DEFAULT_LANG;
  }

  const stored = localStorage.getItem(LANG_KEY);
  if (stored === 'ru' || stored === 'en') {
    return stored;
  }

  try {
    localStorage.setItem(LANG_KEY, DEFAULT_LANG);
  } catch {
    // ignore serialization errors
  }
  return DEFAULT_LANG;
}

const initialLang = resolveInitialLang();
if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('lang', initialLang);
  // Инициализируем мета-теги из хеша при загрузке страницы
  initMetaTagsFromHash();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
